import baseApi from "./baseApi";
import apiPaths from "./apiPaths";
import { ReportConfigModel } from "../models/report/ReportConfigModel";
import { TemplateModel } from "../models/template/TemplateModel";
import { ReportFilterModel } from "../models/report/ReportFilterModel";
import { DashboardConfigModel } from "../models/report/DashboardConfigModel";
import { DefaultReportConfigModel } from "../models/report/DefaultReportConfigModel";

export class reportsApi extends baseApi {
    constructor(baseUrl: string, userId: string) {
        super(baseUrl, userId);
    }

    public async postReportConfig(userId: string, reportConfig: ReportConfigModel) {
        return await this.Post(apiPaths.postReportConfig(userId), reportConfig);
    }

    public async postReportTemplate(userId: string, reportTemplate: TemplateModel) {
        return await this.Post(apiPaths.postReportTemplate(userId), reportTemplate);
    }

    public async postReportFilter(userId: string, reportFilter: ReportFilterModel) {
        return await this.Post(apiPaths.postReportFilter(userId), reportFilter);
    }

    public async postDashboardConfig(userId: string, dashboardConfig: DashboardConfigModel) {
        return await this.Post(apiPaths.postDashboardConfig(userId), dashboardConfig);
    }

    public async getReportTemplates(userId: string) {
        return await this.Get(apiPaths.getReportTemplates(userId));
    }

    public async getReportConfigs(userId: string) {
        return await this.Get(apiPaths.getReportConfigs(userId));
    }

    public async getReportConfigsFromMedia(userId: string) {
        return await this.Get(apiPaths.getReportConfigsFromMedia(userId));
    }

    public async getReportConfig(userId: string, reportId: string) {
        return await this.Get(apiPaths.getReportConfig(userId, reportId));
    }

    public async getReportFilters(userId: string) {
        return await this.Get(apiPaths.getReportFilters(userId));
    }

    public async getReportFiltersFromMedia(userId: string) {
        return await this.Get(apiPaths.getReportFiltersFromMedia(userId));
    }

    public async getReportFilter(userId: string, reportFilterId: string) {
        return await this.Get(apiPaths.getReportFilter(userId, reportFilterId));
    }

    public async getTemplateFromReports(userId: string, templateId: string, includeSubTemplates: boolean = false) {
        return await this.Get(apiPaths.getTemplateFromReports(userId, templateId, includeSubTemplates));
    }

    public async GetTemplateFromMedia(userId: string, templateId: string, includeSubTemplates: boolean = false) {
        return await this.Get(apiPaths.getTemplateFromMedia(userId, templateId, includeSubTemplates));
    }
    
    public async GetBroadcastTemplateFromReports(userId: string) {
        return await this.Get(apiPaths.getBroadcastTemplateFromReports(userId))
    }

    public async GetTemplatesFromMedia(userId: string) {
        return await this.Get(apiPaths.getTemplatesFromMedia(userId));
    }

    public async GetTemplatesByConfigFromMedia(userId: string, reportId: string) {
        return await this.Get(apiPaths.getTemplatesByConfigFromMedia(userId, reportId));
    }

    public async GetTemplatesByReportTypeFromMedia(userId: string, reportType: number) {
        return await this.Get(apiPaths.getTemplatesByReportTypeFromMedia(userId, reportType));
    }

    public async GetDefaultReportConfigFromMedia(userId: string) {
        return await this.Get(apiPaths.getDefaultReportConfigFromMedia(userId));
    }

    public async GetTemplatesByReportTypeFromReports(userId: string, reportType: number) {
        return await this.Get(apiPaths.getTemplatesByReportTypeFromReports(userId, reportType));
    }

    public async GetDefaultReportConfigFromReports(userId: string) {
        return await this.Get(apiPaths.getDefaultReportConfigFromReports(userId));
    }

    public async PostDefaultReportConfigFromReports(userId: string, defaultReportConfig: DefaultReportConfigModel) {
        return await this.Post(apiPaths.postDefaultReportConfig(userId), defaultReportConfig);
    }

    public async GetDashboardConfigFromReports(userId: string) {
        return await this.Get(apiPaths.getDashboardConfigFromReports(userId));
    }

    public async GetTeamMatchReport(reportId: string, matchId: string, teamId: string, reportFilterId: string) {
        return await this.Get(apiPaths.GetTeamMatchReport(reportId, matchId, teamId, reportFilterId));
    }

    public async GetPlayerMatchReport(reportId: string, matchId: string, playerId: string, teamId: string, reportFilterId: string) {
        return await this.Get(apiPaths.GetPlayerMatchReport(reportId, matchId, playerId, teamId, reportFilterId));
    }

    public async GetTeamSeasonReport(reportId: string, seasonId: string, teamId: string, reportFilterId: string) {
        return await this.Get(apiPaths.GetTeamSeasonReport(reportId, seasonId, teamId, reportFilterId));
    }

    public async GetPlayerSeasonReport(reportId: string, seasonId: string, playerId: string, teamId: string, reportFilterId: string) {
        return await this.Get(apiPaths.GetPlayerSeasonReport(reportId, seasonId, playerId, teamId, reportFilterId));
    }

    public async GetTeamSeriesReport(reportId: string, seriesId: string, teamId: string, reportFilterId: string) {
        return await this.Get(apiPaths.GetTeamSeriesReport(reportId, seriesId, teamId, reportFilterId));
    }

    public async GetPlayerSeriesReport(reportId: string, seriesId: string, playerId: string, teamId: string, reportFilterId: string) {
        return await this.Get(apiPaths.GetPlayerSeriesReport(reportId, seriesId, playerId, teamId, reportFilterId));
    }

    public async GetMatchReport(reportId: string, matchId: string, reportFilterId: string) {
        return await this.Get(apiPaths.GetMatchReport(reportId, matchId, reportFilterId));
    }

    public async GetSeasonReport(reportId: string, seasonId: string, reportFilterId: string) {
        return await this.Get(apiPaths.GetSeasonReport(reportId, seasonId, reportFilterId));
    }

    public async GetSeriesReport(reportId: string, seriesId: string, reportFilterId: string) {
        return await this.Get(apiPaths.GetSeriesReport(reportId, seriesId, reportFilterId));
    }

    public async GetMetricPlaylist(reportId: string, queryId: string, seasonId: string, matchId: string, teamId: string, playerId: string, name: string) {
        return await this.Get(apiPaths.getMetricPlaylist(reportId, queryId, seasonId, matchId, teamId, playerId, name));
    }
}